function parsePhoneNumber(phoneNumber) {
  const cleaned = `${phoneNumber}`.replace(/\D/g, '');
  // Check if the input is of correct length
  const match = /^(\d{3})(\d{3})(\d{4})$/.exec(cleaned);

  if (match) {
    return {
      // Return the formatted string
      formatNational: () => `(${match[1]}) ${match[2]}-${match[3]}`,
      // Return the URI
      getURI: () => `tel:+1${match[1]}${match[2]}${match[3]}`,
    };
  }
  // If the input is not of correct length return the original string
  return {
    formatNational: () => phoneNumber,
    getURI: () => `tel:${phoneNumber}`,
  };
}

export default parsePhoneNumber;
